import { openapi_website_cms_addNewMarketFilter, Response200Type, decodeResponse200 } from 'src/api_openapi/generated/openapi_website_cms_addNewMarketFilter';
import { MethodType, ParamsFetchType, GenerateUrlApiType, ResponseType } from 'src_common/browser/apiUtils';
import { GenerateUrlApiParamsType } from 'src_common/server/webDriver/sdkApiWebUtils';

export type TransactionItemType = Response200Type extends Array<infer Model> ? Model : never;

const decode = (status: number, data: ResponseType): Response200Type  => {
    if (status === 200 && data.type === 'json') {
        return decodeResponse200(data.json);
    }

    throw new Error(`unhandled response ${status} - ${data.type}`);
};

export interface MarketFilterParams {
        display_order: number,
        filter_name: string,
        filter_slug: string,
        sport_name: string,
}

export const addNewMarketFilter = {
    browser: {
        params: (params: MarketFilterParams): ParamsFetchType<MarketFilterParams> => {
            return {
                type: MethodType.POST,
                url: '/api-web/add-market-filters',
                body: params
            };
        },
        decode: decode
    },
    express: {
        method: MethodType.POST,
        urlBrowser: '/api-web/add-market-filters',
    },
    generateUrlApi: async (params: GenerateUrlApiParamsType<MarketFilterParams>): Promise<GenerateUrlApiType> => {

        const resp = await openapi_website_cms_addNewMarketFilter(params.API_URL, params.API_TIMEOUT, params.jwtToken, {
            universe: params.API_UNIVERSE,
            body: params.req.body
        });

        return {
            passToBackend: false,
            status: resp.status,
            responseBody: resp.body
        };
    }
};
